import React from "react";
import Index from "../components/homepage/main-screen/index";
import PlayersLeaderboard from "../components/authComponents/LoginPopUp";

const HomePage = () => {
  return (
    <>
      <Index />
      {/* <PlayersLeaderboard/> */}
    </>
  );
};

export default HomePage;
